import styled from "styled-components";
import { Text, Image, Box } from "@vinomofo/components";

const LogoCollectionContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 10px;
  margin: 0 auto;
  position: relative;
  z-index: 109;

  @media ${({ theme }) => theme.mq.max.mobile} {
    margin: -10px auto 0px;
    padding: 20px 10px 20px;
  }
`;

const StyledSubText = styled(Text)`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 24px;
  font-weight: 100;
  line-height: 140%;
  letter-spacing: 2%;
  text-align: center;
  color: #dec28f;
  padding-top: 60px;
  margin-bottom: 20px;
  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 20px;
    padding-top: 60px;
    max-width: 25rem;
  }
`;

const StyledText = styled(Text)`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 52px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 2%;
  text-align: center;
  max-width: 60%;
  letter-spacing: 0.001em;
  color: ${({ theme }) => theme.colors.white};
  padding-top: 30px;
  margin-bottom: 20px;
  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 35px;
    letter-spacing: 0.001em;
    padding-top: 60px;
    max-width: 90%;
  }
`;

const StyledTagline = styled(Text)`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 24px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 2%;
  text-align: center;
  color: #b1b1b1;
  padding-top: 40px;
  margin-bottom: 20px;
  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 20px;
    padding-top: 60px;
    max-width: 25rem;
  }
`;

const LogoImage = styled(Image)`
  max-width: 100%;
  height: auto;

  mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 15%,
    black 85%,
    transparent 100%
  );

  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 15%,
    black 85%,
    transparent 100%
  );
`;

interface LogoCollectionProps {
  heading: string;
  subheading?: string;
  tagline?: string;
  logoImageUrl: string;
  logoAltText?: string;
}

export const LogoCollection = ({
  subheading,
  heading,
  tagline,
  logoImageUrl,
  logoAltText = "Brand logos collection",
}: LogoCollectionProps) => {
  return (
    <LogoCollectionContainer>
      <StyledSubText>{subheading}</StyledSubText>
      <StyledText>{heading}</StyledText>
      <StyledTagline>{tagline}</StyledTagline>
      <LogoImage src={logoImageUrl} alt={logoAltText} />
    </LogoCollectionContainer>
  );
};
